import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LoadingOverlay from "react-loading-overlay";
import size from "lodash/size";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import Select from "react-select";
import { getPrimaryRedTheme } from "../../../../common/themes";
import Confirm from "../../common/confirm/confirm";
import { RouteComponentProps } from "react-router-dom";
import { IProject, IApplicationState, IUserEndPoint } from "../../../../models/applicationState";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IUserDefinedActions, * as userDefinedActions from "../../../../redux/actions/userDefinedActions";

export interface IUserValidationsProps extends RouteComponentProps, React.Props<UserValidations> {
    project: IProject;
    actions: IProjectActions;
    userDefinedActions: IUserDefinedActions;
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        userDefinedActions: bindActionCreators(userDefinedActions, dispatch),
    };
}

export interface IUserValidationsState {
    addEndPoint: boolean;
    userValidations: IUserEndPoint[];
    project: IProject;
    project_name: string;
    validationIndex: any;
    loadEndPoints: boolean;
    createValidation: boolean;
    endpoint: string;
    deleteEndPoint: boolean;
    validationCheck: boolean;
    endpoint_name: string;
    labelString: string;
    userEnabledDisableEndPoint: boolean;
    status: any;
    category: string;
}

@connect(mapStateToProps, mapDispatchToProps)

export default class UserValidations
    extends React.Component<IUserValidationsProps, IUserValidationsState> {
    public state: IUserValidationsState = {
        addEndPoint: false,
        project: this.props.project,
        project_name: null,
        endpoint_name: null,
        endpoint: null,
        userValidations: [],
        deleteEndPoint: false,
        validationCheck: true,
        createValidation: false,
        category: null,
        labelString: "updating End Point",
        validationIndex: null,
        userEnabledDisableEndPoint: false,
        loadEndPoints: false,
        status: null,
    };

    private onDeleteEndPointConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;

    public componentDidMount() {
        const projectName = this.props.match.params["projectName"];
        this.getValidationsTransform(projectName);
    }

    public render() {
        const { endpoint_name, endpoint, status, validationCheck } = this.state;
        const options = [
            { value: 'enable', label: 'Enable' },
            { value: 'disable', label: 'Disabled' },
        ];
        return (
            <>
                <div className="container">

                    <div className="row mt-2">

                        <div className="col-md-12">
                            <div className="float-right">
                                <div className="input-group input-group-sm  float-right"><div className="input-group-prepend"><span className="input-group-text" id="inputGroup-sizing-sm">Add Validation</span></div><div className="input-group-append"><button className="btn-add-row-col" type="button" onClick={() => this.showForm()}> <i className="fa fa-plus" aria-hidden="true"> </i> </button></div></div>
                            </div>

                        </div>
                    </div>

                    <div className="row">

                        <div className="col-md-12">
                            <div className="advanced-card wrap-userdefined">

                                {!this.state.loadEndPoints ?
                                    <>
                                        {size(this.state.userValidations) > 0 ?
                                            this.state.userValidations.map((data, index) => {
                                                return (
                                                    <div key={index}>
                                                        {this.state.validationIndex !== index &&
                                                            <div className="tile" >
                                                                <div className="s-no">{index + 1}</div>
                                                                <a role="button" onClick={() => this.deleteEndPoint(data, index)} className="cursor-pointer del">
                                                                    <i
                                                                        className="fa fa-trash bg-color-1"
                                                                        aria-hidden="true"
                                                                    ></i>
                                                                </a>

                                                                <div className="custom-control custom-switch switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        value={data._id}
                                                                        onChange={(event) => this.changeEndPointStatus(event, data, index)}
                                                                        checked={data.active_status === "enable" ? true : false}
                                                                        className="custom-control-input"
                                                                        id={`customSwitch1${index + 1}`}
                                                                    />
                                                                    <label
                                                                        className="custom-control-label"
                                                                        htmlFor={`customSwitch1${index + 1}`}
                                                                    >
                                                                        {" "}
                                                                    </label>
                                                                </div>

                                                                <div>
                                                                    <span className="name">{data.endpoint_name}</span>
                                                                </div>
                                                                <div className="mt-2 url_css" title="enpoint url">
                                                                    <i className="fa fa-link" aria-hidden="true"></i> {data.endpoint}
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.userEnabledDisableEndPoint
                                                            && this.state.validationIndex === index && <Spinner className="tile" size={SpinnerSize.small} label={this.state.labelString} ariaLive="off" labelPosition="right" />}
                                                    </div>
                                                );
                                            })
                                            : <div className="text-center mt-5">No Data Available</div>}
                                    </>
                                    : <Spinner className="mt-5" label="Loading Validations" size={SpinnerSize.small} />
                                }
                            </div></div></div>
                </div>

                {this.state.addEndPoint &&
                    <div className="model_add">
                        <LoadingOverlay
                            active={this.state.createValidation}
                            spinner
                            text="Creating Validation">
                            <div className="row">

                                <div className="col-md-6 offset-md-3">
                                    <div className="card shadow">

                                        <div className="card-header">
                                            <div className="text-center">
                                                <h5>Add Validation</h5>

                                            </div>
                                        </div>

                                        <div className="card-body">

                                            <div className="row">
                                                {/* <div className="col-md-6" >
                                                <label >Project name:</label>
                                                {this.props.match.params["projectName"]}
                                            </div> */}

                                                <div className="col-md-6" >
                                                    <label >Endpoint name:</label>
                                                    <input type="text" className="form-control" id="endpoint_name" name="endpoint_name"
                                                        onChange={this.getInputValues} placeholder="Endpoint name" />
                                                </div>

                                                {/* <div className="col-md-6" >
                                                <label >Endpoint Type:</label>
                                                <input type="text" className="form-control" id="name" name="endPointType"
                                                    onChange={this.getInputValues} placeholder="Endpoint Type" />
                                            </div> */}

                                                <div className="col-md-6" >
                                                    <label>Endpoint:</label>
                                                    <input type="text" className="form-control" id="endpoint" name="endpoint"
                                                        onChange={this.getInputValues} placeholder="http://www.google.com" />
                                                    {!validationCheck && <div className="text-danger"> Give valid End Point</div>}
                                                </div>

                                                <div className="col-md-6" >
                                                    <label>Category:</label>
                                                    <input type="text" className="form-control" id="category" name="category"
                                                        onChange={this.getInputValues} placeholder="Category" />
                                                </div>
                                                <div className="col-md-6" >

                                                    <label>Status:</label>
                                                    <Select options={options}
                                                        onChange={this.getStatus}
                                                        value={this.state.status}
                                                        placeholder="Select"
                                                        className="react-select-container zindex-20"
                                                        isClearable={true}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#161a1f",
                                                                primary: "#6b727d",
                                                                neutral0: "#222830",
                                                                neutral20: "#44474c",
                                                                neutral30: "#272c33",
                                                                neutral50: "#fff",
                                                                neutral80: "#9da7b5",
                                                            },
                                                        })}

                                                    />

                                                </div>

                                                <div className="col-md-6" >

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <div className="card-footer text-center">
                                        <button type="submit"
                                            disabled={!endpoint_name || !endpoint || !status || !validationCheck}
                                            onClick={this.createValidation}
                                            className="btn btn-sm mr-2">Add</button>
                                        <button type="button"
                                            className="btn btn-sm" onClick={() => this.showForm()}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </LoadingOverlay>
                    </div>
                }
                <Confirm title="Delete this Validation"
                    ref={this.onDeleteEndPointConfirm}
                    message="Are you sure you want to delete this Validation ?"
                    confirmButtonTheme={getPrimaryRedTheme()}
                    onCancel={this.onCancelDeleteEndPoint}
                    onConfirm={this.confirmDeleteEndPoint} />
            </>
        );
    }
    /**
     * get validations and transform
     */
    private getValidationsTransform = async (projectName) => {
        this.setState({ loadEndPoints: true, project_name: projectName });
        if (projectName) {
            const endPointType = {
                project_name: projectName,
                endpoint_type: "validation",
            };
            const loadEndpointData = await this.props.userDefinedActions.loadEndPoints(endPointType);
            if (loadEndpointData) {
                this.setState({ userValidations: loadEndpointData, loadEndPoints: false,validationIndex:23 });
            } else {
                this.setState({ loadEndPoints: false });
            }
        }
    }

    private getStatus = (event) => {
        this.setState({ status: event });
    }
    /**
     * show Form
     */
    private showForm = () => {
        const { addEndPoint } = this.state;
        this.setState({ addEndPoint: !addEndPoint });
    }
    /**
     * get endpoint check
     */
    private changeEndPointStatus = async (event, data, index) => {
        this.setState({ userEnabledDisableEndPoint: true, validationIndex: index });
        const endPointData = {
            project_name: data.project_name,
            endpoint_type: "validation",
            endpoint_name: data.endpoint_name,
            active_status: event.target.checked ? "enable" : "disable",
        }
        const result =  await this.props.userDefinedActions.enableDisableEndPoint(endPointData);
        if (result) {
            const elementIndex = this.state.userValidations.findIndex((element) => element._id === data._id);
            const newArray = [...this.state.userValidations];
            newArray[elementIndex] = { ...newArray[elementIndex], active_status: result }
            this.setState({ userValidations: newArray, userEnabledDisableEndPoint: false, validationIndex: null }); 
        } else {
            this.setState({ userEnabledDisableEndPoint: false, validationIndex: null }); 
        }
    }
    /**
     * Create Validation
     */
    private createValidation = async () => {
        this.setState({ createValidation: true });
        const { endpoint_name, endpoint, category, status } = this.state;
        const endPointData = {
            project_name: this.props.match.params["projectName"],
            endpoint_type: "validation",
            category,
            active_status: status.value,
        };
        const body = {};
        body["endpoint_name"] = endpoint_name;
        body["endpoint"] = endpoint;
        await this.props.userDefinedActions.createEndPoint(endPointData, body);
        // if (data === "validation endpoint updated successfully!") {
        this.setState({ endpoint: null, endpoint_name: null, status: null, category: null, createValidation: false, addEndPoint: false });
        this.getValidationsTransform(endPointData.project_name);
    }
    /**
     * get event values based on name
     */
    private getInputValues = (event) => {
        if (event.target.name === "endpoint") {
            const regexQuery = "^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$";
            const url = new RegExp(regexQuery, "i");
            if (url.test(event.target.value)) {
                this.setState({ ...this.state, validationCheck: true, [event.target.name]: event.target.value });
            } else {
                this.setState({ validationCheck: false });
            }
        } else {
            this.setState({ ...this.state, [event.target.name]: event.target.value });
        }
    }
    /**
     * Delete Validation
     */
    /** delete file */
    private deleteEndPoint = (endPoint: IUserEndPoint, index) => {
        this.onDeleteEndPointConfirm.current.open(endPoint, index);
    }
    /**
     * on Cancel Delete EndPoint
     */
    private onCancelDeleteEndPoint = () => {
        if (this.renameCanceled) {
            this.renameCanceled();
            this.renameCanceled = null;
        }
    }
    /**
     * Confirm Delete End Point
     */
    private confirmDeleteEndPoint = async (endPoint: IUserEndPoint, index) => {
        const endPointData = {
            project_name: endPoint.project_name,
            endpoint_type: "validation",
            endpoint_name: endPoint.endpoint_name,
        }
        this.setState({ userEnabledDisableEndPoint: true, labelString: "Deleting End Point", validationIndex: index });
        await this.props.userDefinedActions.deleteEndPoint(endPointData);
        const newArray = [...this.state.userValidations];
        const index_endPoint = await newArray.indexOf(endPoint);
        if (index_endPoint > -1) {
            newArray.splice(index_endPoint, 1);
        }
        this.setState({ userValidations: newArray, userEnabledDisableEndPoint: false,validationIndex: 23 });
    }
}
